export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  AssetGroup: 'assetGroup',
  Ad: 'ad',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  CampaignNegativeWebpage: 'campaignNegativeWebpage',
  AdGroupLocation: 'adGroupLocation',
  AdGroupRadius: 'adGroupRadius',
  AdGroupNegativeLocation: 'adGroupNegativeLocation',
  AdGroupLocationIntent: 'adGroupLocationIntent',
  AdGroupDayTimeCriterion: 'adGroupDayTimeCriterion',
  AdGroupNegativeWebpage: 'adGroupNegativeWebpage',
  AdGroupLocationTargetError: 'AdGroup Location Criterion Error',
};
